import React from 'react'
import { PropTypes } from 'prop-types'
import WarningIcon from 'assets/images/ln-icon-warning-exclamation.svg'
import { OutlinedButton, FilledButton } from '@jsluna/react'

const ModalAlert = props => (
  <div className={props.modalAlertOpen ? 'ln-c-modal js-modal is-open' : 'ln-c-modal js-modal'}>
    <div className="ln-u-fill-height ln-c-modal-alert-banner-top">
      <div
        className="ln-c-modal__body ln-c-modal-alert__body js-modal-body ln-c-status-card ln-c-status-card--amber"
        id="modalAlert"
        tabIndex="0"
        role="dialog"
        aria-labelledby="modalAlertTitle"
      >
        <div className="ln-o-flag">
          <div className="ln-o-flag__component">
            <svg
              className="ln-icon-warning-exclamation ln-c-modal-alert-icon-alignment" role="presentation"
              viewBox="0 0 50 50"
            >
              <use xlinkHref={`#${WarningIcon.id}`} />
            </svg>
          </div>
          <div className="ln-o-flag__body">
            <div className="ln-o-flag">
              <div className="ln-o-flag__body">
                <li className="ln-o-matrix-list__item" >
                  {props.name}
                </li>
              </div>
              <div className="ln-o-flag__component ln-o-flag__component--nowrap">
                <OutlinedButton
                  className="ln-c-button ln-c-button--large ln-c-button--secondary ln-c-modal-alert-no-button-alignment"
                  role="button"
                  onClick={props.modalAlertCancel}
                >No
                </OutlinedButton>
                <FilledButton
                  className="ln-c-button ln-c-button--large ln-c-button--primary ln-c-modal-alert-yes-button-alignment"
                  onClick={props.modalAlertSubmit}
                >Yes
                </FilledButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

ModalAlert.propTypes = {
  modalAlertOpen: PropTypes.bool.isRequired,
  modalAlertSubmit: PropTypes.func.isRequired,
  modalAlertCancel: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired
}

export default ModalAlert



// WEBPACK FOOTER //
// ./src/components/ModalAlert/index.jsx